import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { listingCta } from "@/lib/listing";

// CMS-managed empty-result state. Rendered when zero eligible/matching records.
export function ListingEmpty({ cfg, defaultTitle, defaultBody, onReset, testid = "listing-empty" }) {
  const title = String(cfg?.empty_title || "").trim() || defaultTitle;
  const body = String(cfg?.empty_body || "").trim() || defaultBody;
  const cta = listingCta(cfg);
  return (
    <div className="py-20 text-center font-accent text-muted-foreground" data-testid={testid}>
      <div className="font-display text-xl text-charcoal">{title}</div>
      {body && <p className="mt-2 text-sm">{body}</p>}
      <div className="mt-4 flex flex-wrap items-center justify-center gap-3">
        {onReset && (
          <button onClick={onReset} data-testid={`${testid}-reset`} className="flex items-center gap-1 rounded-full border border-charcoal px-4 py-1.5 text-xs text-charcoal hover:bg-charcoal hover:text-white"><X className="h-3 w-3" />Reset filters</button>
        )}
        {cta && (
          cta.href.startsWith("/") ? (
            <Link to={cta.href}><Button size="sm" className="rounded-full bg-saffron text-xs text-white hover:bg-saffron-dark" data-testid={`${testid}-cta`}>{cta.label}</Button></Link>
          ) : (
            <a href={cta.href} target="_blank" rel="noopener noreferrer"><Button size="sm" className="rounded-full bg-saffron text-xs text-white hover:bg-saffron-dark" data-testid={`${testid}-cta`}>{cta.label}</Button></a>
          )
        )}
      </div>
    </div>
  );
}
